/**
 * The status of an Order and wait row, order or PO, in words (BLU-1506):
 * Not sent yet / On the way, due 28 Oct / Late, was due 23 Oct / Out at
 * {supplier} / Short, on next order / Arrived. Drawn with the shared
 * `StatusPill` (ring geometry, the words inside, colour never alone); the
 * words and the tone come from `orderAndWaitStatusLabel` and
 * `orderAndWaitStatusTone` (lib/order-and-wait).
 */
import { useTranslation } from 'react-i18next';
import { StatusPill } from '@/components/shared/StatusPill';
import { useDateFnsLocale } from '@/lib/format-dates';
import { orderAndWaitStatusLabel, orderAndWaitStatusTone } from '../lib/order-and-wait';

interface OrderAndWaitStatusChipProps {
  status: string | null | undefined;
  supplierName?: string | null;
  dueDate?: string | null;
  className?: string;
  /** `status` only for a chip whose words change while the page is open. */
  role?: 'status';
}

export function OrderAndWaitStatusChip({ status, supplierName, dueDate, className, role }: OrderAndWaitStatusChipProps) {
  const { t } = useTranslation('orders');
  const locale = useDateFnsLocale();
  return (
    <StatusPill tone={orderAndWaitStatusTone(status)} className={className} role={role}>
      {orderAndWaitStatusLabel(t, status, { supplierName, dueDate, locale })}
    </StatusPill>
  );
}
